<nz-modal [(nzVisible)]="visible" [nzTitle]="titleTpl" [nzWidth]="showPreview ? '80vw' : '500px'"
  [nzMaskClosable]="false" [nzFooter]="footer" (nzOnCancel)="visible = false" (nzOnOk)="sendEmail()">
  <ng-template #titleTpl>
    @switch (action) {
    @case ('email') {
    Share via Email
    }
    @case ('whatsapp') {
    Share via WhatsApp
    }
    @case ('telegram') {
    Share via Telegram
    }
    @case ('link') {
    Share via Link
    }
    }
  </ng-template>

  <ng-container *nzModalContent>
    <div nz-row>
      <div nz-col [nzSm]="showPreview ? 12 : 24" [nzXs]="24">
        <form #emailForm="ngForm" nz-form>
          <div aria-hidden="true" style="position: absolute; left: -9999px; top: -9999px; height: 0; width: 0; overflow: hidden;">
            <label for="companyWebsite">Website</label>
            <input type="text" id="companyWebsite" name="companyWebsite" [(ngModel)]="data.companyWebsite"
              tabindex="-1" autocomplete="off" />
          </div>
          <nz-table class="invoice-email-table" [class.no-preview]="!showPreview">
            @if (showPreview) {
            <tr>
              <td class="title">From:</td>
              <td>
                <input class="email-template-required-field" nz-input email type="email" name="from"
                  [(ngModel)]="data.from" required [nzStatus]="
                      fs.hasError(emailForm, 'from', 'required') ||
                      fs.hasError(emailForm, 'from', 'email')
                        ? 'error'
                        : ''
                    " />
                <small class="text-red" *ngIf="fs.hasError(emailForm, 'from', 'required')">Sender Email is
                  required</small>
                <small class="text-red" *ngIf="fs.hasError(emailForm, 'from', 'email')">Invalid Email Format</small>
              </td>
            </tr>
            <tr>
              <td class="title">To:</td>
              <td>
                <div style="display: flex; align-items: center">
                  <!-- <input
                        class="email-template-required-field"
                        nz-input
                        email
                        type="email"
                        name="to"
                        [(ngModel)]="data.to"
                        required
                        [nzStatus]="
                          fs.hasError(emailForm, 'to', 'required') ||
                          fs.hasError(emailForm, 'to', 'email')
                            ? 'error'
                            : ''
                        "
                      /> -->
                  <input class="email-template-required-field" nz-input type="email" name="to" [(ngModel)]="data.to"
                    (input)="onEmailInput($event, 'to')" [nzAutocomplete]="toEmailAuto" required
                    placeholder="Enter email or select from suggestions"
                    [nzStatus]="hasInvalidEmails('to') ? 'error' : ''" style="width: 100%" />
                  <nz-autocomplete nzBackfill #toEmailAuto>
                    <nz-auto-optgroup *ngIf="data.primaryEmail && shouldShowPrimaryEmail()" nzLabel="Primary Email">
                      <nz-auto-option [nzValue]="data.primaryEmail"
                        [nzDisabled]="isEmailDisabled(data.primaryEmail, 'to')">
                        {{ data.primaryEmail }}
                      </nz-auto-option>
                    </nz-auto-optgroup>
                    <nz-auto-optgroup *ngIf="filteredEmailSuggestions && filteredEmailSuggestions.length > 0"
                      nzLabel="Secondary Email">
                      <nz-auto-option *ngFor="let email of filteredEmailSuggestions" [nzValue]="email"
                        [nzDisabled]="isEmailDisabled(email, 'to')">
                        {{ email }}
                      </nz-auto-option>
                    </nz-auto-optgroup>
                  </nz-autocomplete>
                  <button type="button" nz-button nzType="primary" (click)="toggleBccField()" style="margin-left: 8px">
                    {{ isBccVisible ? 'BCC' : 'BCC' }}
                  </button>
                </div>

                <small class="text-red" *ngIf="fs.hasError(emailForm, 'to', 'required')">Recipient Email is
                  required</small>
                <small class="text-red" *ngIf="fs.hasError(emailForm, 'to', 'email')">Invalid Email Format</small>
              </td>
            </tr>
            <tr>
              <td class="title">Cc:</td>
              <td>
                <!-- <nz-select
                    nzMode="tags"
                    [nzDropdownStyle]="{ display: 'none' }"
                    name="cc"
                    [(ngModel)]="data.ccList"
                    style="width: 100%"
                  >
                  </nz-select> -->
                <nz-select nzMode="tags" nzPlaceHolder="Select CC emails or add new ones..." name="ccList"
                  [(ngModel)]="data.ccList" style="width: 100%">
                  <nz-option-group nzLabel="Primary Email">
                    <nz-option *ngIf="data.primaryEmail" [nzValue]="data.primaryEmail" [nzLabel]="data.primaryEmail"
                      [nzDisabled]="
                          isEmailDisabled(data.primaryEmail, 'ccList')
                        ">
                    </nz-option>
                  </nz-option-group>
                  <nz-option-group nzLabel="Secondary Email">
                    <nz-option *ngFor="let email of data.ccOptions" [nzLabel]="email" [nzValue]="email"
                      [nzDisabled]="isEmailDisabled(email, 'ccList')">
                    </nz-option>
                  </nz-option-group>
                </nz-select>
              </td>
            </tr>
            <tr *ngIf="isBccVisible">
              <td class="title">Bcc:</td>
              <td colspan="2">
                <nz-select nzMode="tags" [nzDropdownStyle]="{ display: 'none' }" name="bcc" [(ngModel)]="data.bccList"
                  style="width: 100%">
                </nz-select>
              </td>
            </tr>
            <tr>
              <td class="title">Subject:</td>
              <td>
                <div style="
                      position: relative;
                      display: inline-block;
                      width: 100%;
                    ">
                  <input class="email-template-required-field" nz-input type="text" name="subject"
                    [(ngModel)]="data.subject" required [maxlength]="500" (ngModelChange)="updateCharacterCounts()"
                    [nzStatus]="
                        fs.hasError(emailForm, 'subject', 'required')
                          ? 'error'
                          : ''
                      " />
                </div>
                <div style="
                      display: flex;
                      flex-direction: row-reverse;
                      font-size: 12px;
                    ">
                  {{ subjectLength }}/500
                </div>
                <small class="text-red" *ngIf="fs.hasError(emailForm, 'subject', 'required')">Email Subject is
                  required</small>
              </td>
            </tr>
            } @else {
            @if (action !== 'link') {
            <tr>
              <td class="title">Recipient:</td>
              <td>
                <app-text-input name="phoneNumber" required [(ngModel)]="data.phoneNumber" maxlength="100"
                  app-mobile-input [allowDialCode]="false"></app-text-input>
                <small class="text-red" *ngIf="fs.hasError(emailForm, 'phoneNumber', 'required')">Receipient Phone
                  Number is required</small>
                <div class="small-remark">e.g. 60122003080</div>
              </td>
            </tr>
            }
            }
            <tr>
              <td class="title align-top">Message:</td>
              <td>
                <div style="position: relative">
                  <textarea nz-input rows="13" style="resize: none" name="message" [(ngModel)]="data.message"
                    [maxlength]="4000" (ngModelChange)="textChanged()">
                  </textarea>
                </div>
                <div style="
                    display: flex;
                    flex-direction: row-reverse;
                    font-size: 12px;
                  ">
                  {{ contentLength }}/4000
                </div>
              </td>
            </tr>
          </nz-table>
        </form>
      </div>

      @if (showPreview) {
      <div class="email-preview-container" nz-col [nzSm]="12" [nzXs]="24">
        <!-- Please dont modify this part to class, all css should be inline style -->
        <!-- Will be used for email rendering in later stage-->
        <div class="email-preview" id="email-preview">
          <!--Header-->
          <div style="display: flex">
            <!-- Company Image -->
            <div>
              <img [src]="companyLogo" style="width: auto; height: 100px; margin-top: 24px" />
            </div>

            <div style="
                  background-color: #08306b;
                  color: white;
                  width: 100%;
                  padding-left: 10px;
                  padding-top: 10px;
                ">
              <div style="font-size: 24px; font-weight: 500">Your Invoice is Ready!</div>
              <!--Summary Group-->
              <div style="display: flex; margin: 5px 0px">
                <div style="margin-right: 20px">
                  <div style="
                        color: lightgray;
                        font-size: 13px;
                        font-weight: 500;
                      ">Total</div>
                  <div style="font-size: 16px">{{
                    data.netTotal | currency: ' '
                    }}</div>
                </div>
                <div>
                  <div style="
                        color: lightgray;
                        font-size: 13px;
                        font-weight: 500;
                      ">Due On</div>
                  <div style="font-size: 16px">{{
                    data.formattedDueDate
                    }}</div>
                </div>
              </div>
              <!--END: Summary Group-->

              <!--Button-->
              <div style="margin: 5px 0px">
                <a style="
                      background: #e8a706;
                      border-radius: 7px;
                      color: black;
                      display: inline-block;
                      font-size: 14px;
                      font-weight: 700;
                      line-height: 20px;
                      margin: 0;
                      margin-top: 7px;
                      padding: 6px 10px;
                      text-decoration: none;
                    " target="_blank" [href]="data.link">
                  Review And Pay
                </a>
              </div>
              <!--END: Button-->
            </div>
          </div>

          <!--Body-->
          <div style="padding: 10px">
            <div class="email-body" [innerHTML]="data.preview"></div>
          </div>
        </div>
      </div>
      }
    </div>
  </ng-container>

  <ng-template #footer>
    @if (showPreview) {
    <div class="footer-container" style="display: flex; justify-content: space-between">
      <div class="footer-detail" style="display: flex; align-items: center">
        <div class="report-format-container">
          <div class="footer-title">Format: </div>
          <nz-select style="margin-right: 6px; max-width: 200px" [(ngModel)]="selectedReport" name="selectedReport"
            [nzDropdownMatchSelectWidth]="false" [nzDropdownClassName]="'format-dropdown'">
            <nz-option nzCustomContent [nzLabel]="format.displayName" [nzValue]="format.reportUrl"
              *ngFor="let format of reportFormats">
              <span *ngIf="!format.isDefault">{{ format.displayName }}</span>
              <strong *ngIf="format.isDefault">{{
                format.displayName
                }}</strong>
            </nz-option>
          </nz-select>
        </div>
        <label class="unhighlightable" nz-checkbox [(ngModel)]="data.sendCopy" name="sendCopy">Send me a copy</label>
        <label class="unhighlightable" nz-checkbox [(ngModel)]="data.includeAttachment" name="includeAttachment">Include
          PDF File</label>
      </div>
      <div class="footer-button" style="display: flex">
        <button type="button" nz-button nzType="default" (click)="visible = false">Cancel</button>
        <button type="button" nz-button nzType="primary" [disabled]="!this.selectedReport" (click)="sendEmail()">Send</button>
      </div>
    </div>
    } @else {
    <div class="footer-container" style="display: flex; justify-content: space-between">
      <div class="footer-detail" style="display: flex; align-items: center">
        <div class="report-format-container">
          <div class="footer-title">Format: </div>
          <nz-select style="margin-right: 6px; max-width: 200px" [(ngModel)]="selectedReport" name="selectedReport"
            [nzDropdownMatchSelectWidth]="false" [nzDropdownClassName]="'format-dropdown'">
            <nz-option nzCustomContent [nzLabel]="format.displayName" [nzValue]="format.reportUrl"
              *ngFor="let format of reportFormats">
              <span *ngIf="!format.isDefault">{{ format.displayName }}</span>
              <strong *ngIf="format.isDefault">{{
                format.displayName
                }}</strong>
            </nz-option>
          </nz-select>
        </div>
      </div>
      <div class="footer-button" style="display: flex">
        <button type="button" nz-button nzType="default" (click)="visible = false">Cancel</button>
        <button type="button" nz-button nzType="primary" [disabled]="!this.selectedReport" (click)="generateShareLink()"
          style="margin-left: 8px">
          @if (action === 'link') {
          Generate Link
          } @else {
          Send
          }
        </button>
      </div>
    </div>
    }
  </ng-template>
</nz-modal>